import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
  })
  export class SubcityDataService {
    private subcityDataSubject = new BehaviorSubject<any>(null);
    subcityData$ = this.subcityDataSubject.asObservable();
  
    setSubcityData(data: any): void {
      this.subcityDataSubject.next(data);
    }
  
    getSubcityData() {
      return this.subcityDataSubject.getValue();
    }
  
    getEnumByKey(key: string): any {
      const subcityData = this.getSubcityData();
      return subcityData ? subcityData[key] : null;
    }
  }
  